import styled from "styled-components";
import {
  COLORS,
  TYPOGRAPHY,
  BREAKPOINTS
} from "../../containers/impact-report/constants";

export const SectionTitle = styled.h2`
  ${TYPOGRAPHY.H2_MOBILE}
  color: ${COLORS.NEUTRAL_500};
  text-align: center;
  margin: 0 0 16px 0;

  @media (min-width: ${BREAKPOINTS.MD}) {
    ${TYPOGRAPHY.HEADING_XLARGE_MEDIUM}
    margin-bottom: 32px;
  }
`;

export const TableWrapper = styled.div`
  margin-top: 16px;
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  background-color: ${COLORS.WHITE};
  border: 1px solid ${COLORS.BORDER_COLOR};
  border-radius: 4px;
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;
  table-layout: auto;

  @media (min-width: ${BREAKPOINTS.LG}) {
    table-layout: fixed;
  }

  tbody tr:hover {
    background-color: ${COLORS.BG_COLOR};
  }
`;

export const TableHead = styled.thead`
  background-color: ${COLORS.BG_COLOR};
`;

export const StyledTableHeader = styled.th`
  text-align: left;
  padding: 16px;
  border-bottom: 1px solid ${COLORS.BORDER_COLOR};
  color: ${COLORS.NEUTRAL_300};
  cursor: ${props => (props.sortable ? "pointer" : "default")};
  user-select: none;
  ${TYPOGRAPHY.BODY_NORMAL_MEDIUM};

  ${props =>
    props.sortable &&
    `
    &:hover {
      color: ${COLORS.NEUTRAL_500};
    }
  `}
`;

export const SortableHeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SortIcon = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const SortArrow = styled.div`
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  ${props =>
    props.direction === "up"
      ? `border-bottom: 6px solid ${
          props.active ? COLORS.NEUTRAL_500 : COLORS.NEUTRAL_300
        };`
      : `border-top: 6px solid ${
          props.active ? COLORS.NEUTRAL_500 : COLORS.NEUTRAL_300
        };`}
`;

export const StyledTableCell = styled.td`
  padding: 16px;
  border-bottom: 1px solid ${COLORS.BORDER_COLOR};
  ${TYPOGRAPHY.BODY_NORMAL_LIGHT};

  ${props =>
    props.truncate &&
    `
    overflow: visible;
    text-overflow: clip;
    white-space: normal;

    @media (min-width: ${BREAKPOINTS.LG}) {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    a {
      display: inline-block;
      max-width: 100%;
      vertical-align: bottom;
      overflow: visible;
      text-overflow: clip;
      white-space: normal;

      @media (min-width: ${BREAKPOINTS.LG}) {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    &:hover {
      position: static;
      overflow: visible;
      white-space: normal;
      word-break: normal;

      @media (min-width: ${BREAKPOINTS.LG}) {
        position: relative;
        word-break: break-word;
      }
    }

    &:hover a {
      overflow: visible;
      white-space: normal;
      max-width: 100%;

      @media (min-width: ${BREAKPOINTS.LG}) {
        max-width: none;
      }
    }
  `}
`;

export const StyledTableLink = styled.a.attrs({
  target: "_blank",
  rel: "noopener noreferrer"
})`
  color: ${COLORS.LINK_BLUE};
  ${TYPOGRAPHY.TEXTLINK_NORMAL_MEDIUM}
`;
